import { PaymentGatewayAccountUnlinkUI } from '@monetize/types/app';
import { Control, Controller, useFormState } from 'react-hook-form';
import {
  MBox,
  MFormField,
  MText,
  MTextarea,
} from '../../../components/Monetize';

interface GatewayAccountUnlinkFormProps {
  control: Control<PaymentGatewayAccountUnlinkUI>;
}

export const GatewayAccountUnlinkForm: React.FC<
  GatewayAccountUnlinkFormProps
> = ({ control }: GatewayAccountUnlinkFormProps) => {
  const { errors } = useFormState({ control });

  return (
    <MBox>
      <MBox mb={4}>
        <MText>Any payment methods without payments will be deleted.</MText>
        <MText>
          Any payment methods with associated payments will be made inactive and
          can no longer be used.
        </MText>
        <MText>
          All existing electronic payments will not be eligible for refunds in
          MonetizeNow.
        </MText>
      </MBox>

      <MFormField label="Reason" error={errors?.cancellationReason} mb="2">
        <Controller
          name="cancellationReason"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <MTextarea {...field} value={field.value ?? ''} />
          )}
        />
      </MFormField>
    </MBox>
  );
};
